// ------------------------------------------------------------------------------------------------------------------------------------
// Footer menu expand 
// ------------------------------------------------------------------------------------------------------------------------------------

var footerHeadings = document.querySelectorAll('.footer-block--menu .footer-block__heading');

footerHeadings.forEach(heading =>{

  heading.addEventListener('click', (e) => {

    if ( window.innerWidth < 750 ) {
      const next = e.currentTarget.nextElementSibling;

      if (next.classList.contains('open')) {
        next.classList.remove('open');
      } else {
        next.classList.add('open');
      }
      
    }

  });
  
});


// ------------------------------------------------------------------------------------------------------------------------------------
// Product Forms
// ------------------------------------------------------------------------------------------------------------------------------------

var enquiryButton = document.querySelector('.product-enquiry .button');
var customisationButton = document.querySelector('.product-quote .button');
var productForm = document.querySelector('.contact-pop-up');
var productFormClose = document.querySelector('.contact-pop-up .contact .close');

if (productForm) {

  [enquiryButton, customisationButton].forEach(function(button) {
    if (button) {
      button.addEventListener('click', function () {
        productForm.classList.add('is-open');
      });
    }
  });

  productForm.addEventListener('click', function (e) {
    if (e.target === productForm) {
      productForm.classList.remove('is-open');
    }
  });

  if (productFormClose) {
    productFormClose.addEventListener('click', function () {
      productForm.classList.remove('is-open');
    });
  }

}